module.exports = __webpack_public_path__ + "static/img/getz_push_close.7cb921b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/getz_push_close.png
// module id = 105
// module chunks = 18